import { render, staticRenderFns } from "./package-summary.vue?vue&type=template&id=15b66cfe"
import script from "./package-summary.vue?vue&type=script&lang=js"
export * from "./package-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports